// extracted by mini-css-extract-plugin
export default {"formContainer":"Space_formContainer__9c3f9","title":"Space_title__1GxJP"};